<template>
  <div v-on:focusin="onFocus" v-on:focusout.stop="onBlur">
    <mobile-date-range-picker
    v-if="isMobile() || compact"
    :attribute="attribute"
    :dateRange.sync="dateRange"
    :ranges="ranges"
    :preventEmit="preventEmit"
    :dateRangeLabel.sync="dateRangeLabel"
    :avoidUpdatingLabel.sync="avoidUpdatingLabel"
    :showDatepicker="showDatepicker"
    :header="header || ''"
    :right="right"
    @preventEmit="preventEmitfunct"
    >
    </mobile-date-range-picker>
    <desktop-date-range-picker
    v-else
    :attribute="attribute"
    :dateRange.sync="dateRange"
    :ranges="ranges"
    :preventEmit="preventEmit"
    :dateRangeLabel.sync="dateRangeLabel"
    :avoidUpdatingLabel.sync="avoidUpdatingLabel"
    :showDatepicker="showDatepicker"
    :header="header || ''"
    :right="right"
    @preventEmit="preventEmitfunct"
    >
    </desktop-date-range-picker>
  </div>
</template>
  
<script>
import { DateTime } from "luxon";
import { QUERY_PARAMETERS } from "@/constants";
import { DateRanges } from "@/dateRanges";
import MobileDateRangePicker from './MobileDateRangePicker.vue';
import DesktopDateRangePicker from './DesktopDateRangePicker.vue';

export default {
name: "date-range-picker",
components: {
  MobileDateRangePicker, 
  DesktopDateRangePicker,
},
props: {
  startDate: {
    required: true,
    type: DateTime,
  },
  endDate: {
    required: true,
    type: DateTime,
  },
  type: {
    requried: true,
    type: String,
  },
  right: {
    required: false,
    type: Boolean,
  },
  header: {
    required: false,
    type: String,
  },
  compact: {
    required: false,
    type: Boolean,
  },
  customRanges: {
    required: false,
    type: Object,
  }
},
data() {
  return { 
    start_date: null,
    end_date: null,
    dateRange: this.type == "due" ? { 
      start: this.$route.query[QUERY_PARAMETERS.DUE_END_TIME] && new Date(this.$route.query[QUERY_PARAMETERS.DUE_START_TIME]) || this.startDate, 
      end: this.$route.query[QUERY_PARAMETERS.DUE_END_TIME] && new Date(this.$route.query[QUERY_PARAMETERS.DUE_END_TIME]) || this.endDate,
    } :
    { 
      start: this.$route.query[QUERY_PARAMETERS.ISSUE_END_TIME] && new Date(this.$route.query[QUERY_PARAMETERS.ISSUE_START_TIME]) || this.startDate, 
      end: this.$route.query[QUERY_PARAMETERS.ISSUE_END_TIME] && new Date(this.$route.query[QUERY_PARAMETERS.ISSUE_END_TIME]) || this.endDate,
    },
    preventEmit: false,
    showDatepicker: false,
    dateRangeLabel: function() {
      if (this.type == "issue" && this.$route.query.hasOwnProperty(QUERY_PARAMETERS.ISSUE_END_TIME) && this.$route.query.hasOwnProperty(QUERY_PARAMETERS.ISSUE_START_TIME)) {
        let rangeStart = DateTime.fromISO(this.$route.query[QUERY_PARAMETERS.ISSUE_START_TIME]);
        let rangeEnd = DateTime.fromISO(this.$route.query[QUERY_PARAMETERS.ISSUE_END_TIME]);
        const startTime = rangeStart.startOf('day'); const endTime = rangeEnd.endOf('day');
        let obj = Object.entries(this.customRanges || DateRanges).map(([key, value]) => {
          return [
            key,
            value.map(dateObj => dateObj)
          ];
        });
        let thing = obj.find((obj) => {
          let [start, end] = obj[1];
          return startTime.toString() == start.toString() && endTime.toString() == end.toString();
        })
        return thing && thing[0] || "Custom"; 
      }
      else if (this.type == "due" && this.$route.query.hasOwnProperty(QUERY_PARAMETERS.DUE_END_TIME) && this.$route.query.hasOwnProperty(QUERY_PARAMETERS.DUE_START_TIME)) {
        let rangeStart = DateTime.fromISO(this.$route.query[QUERY_PARAMETERS.DUE_START_TIME]);
        let rangeEnd = DateTime.fromISO(this.$route.query[QUERY_PARAMETERS.DUE_END_TIME]);
        const startTime = rangeStart.startOf('day'); const endTime = rangeEnd.endOf('day');
        let obj = Object.entries(this.customRanges || DateRanges).map(([key, value]) => {
          return [
            key,
            value.map(dateObj => dateObj)
          ];
        }).find((obj) => {
          let [start, end] = obj[1];
          return startTime.toString() == start.toString() && endTime.toString() == end.toString();
        });
        return obj && obj[0] || "Custom";
      }
      return "This Month";
    }.apply(this),
    avoidUpdatingLabel: true,
    ranges: this.customRanges || DateRanges,
    timeout: null, // For throttling watcher
    attribute: {
      highlight: {
        start: {
          style: {
            backgroundColor: '#4bcb81', 
          },
          contentStyle: {
            color: '#ffffff' 
          }
        },
        base: {
          style: {
            backgroundColor: '#ebfdf3', 
          }
        },
        end: {
          style: {
            backgroundColor: '#4bcb81', 
          },
          contentStyle: {
            color: '#ffffff'
          }
        }
      }
    }
  };
},
mounted() {
  this.dateRange = {"start" : this.startDate, "end" : this.endDate};
},
methods: {
  addDateFilter(){
    this.start_date = this.dateRange.start;
    this.end_date = this.dateRange.end;
    if(this.start_date?.ts ?? null ===this.end_date?.ts ) {
      this.start_date = this.start_date.startOf('day')
      this.end_date = this.end_date.endOf('day')
    }

    if (!this.preventEmit) {
      // this.showDatepicker = false;
      this.$emit("date-select",{
        startDate: this.start_date.toUTC().toString(),
        endDate: this.end_date.toUTC().toString(),
      });
    }

    this.preventEmit = false;
  },
  preventEmitfunct(val){
    this.showDatepicker = val;
    this.preventEmit = val;
  },
  resetDate(startTime, endTime) {
    this.avoidUpdatingLabel=true;
    this.preventEmit = true;
    this.dateRange = { 
      start: startTime,
      end: endTime,
    };
    this.dateRangeLabel = null;
  },
  onFocus() {
    this.showDatepicker = true;
  },
  onBlur(event) {
    // this.$refs.dateMenu.classList.remove("show");
    if (!event.currentTarget.contains(event.relatedTarget)) {
      // this.showDatepicker = false;
      if (this.showDatepicker) {
        this.showDatepicker = false;
        this.addDateFilter();
      }
    }
  },
  isMobile() {
    if(screen.width <= 600) {
      return true;
    }
    else {
      return false;
    }
  },
},
watch: {
  dateRange: {
    handler(val) {
      if (val) {
        if (this.timeout!==null) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(() => {
          this.addDateFilter();
          if (!this.avoidUpdatingLabel) {
            this.dateRangeLabel = "Custom";
          }
          this.avoidUpdatingLabel = false;
          this.timeout = null;
        }, 850);
      }
    },
    deep: true
  },
}
};
</script>

<style scoped lang="scss">
</style>
  